"use client";

import * as React from "react";
import {
  FilterBuilder,
  type FilterRule,
} from "@/src/components/input/filter-builder";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsFilterBuilder() {
  const [filterRoot, setFilterRoot] = React.useState<FilterRule>({
    rule_type: "and_cond",
    rules: [],
    is_not: false,
    is_case_sensitive: false,
  });

  const code = `import {
  FilterBuilder,
  type FilterRule,
} from "@/registry/new-york/blocks/filter-builder/filter-builder";
import * as React from "react";

export function FilterBuilderDemo() {
  const [filterRoot, setFilterRoot] = React.useState<FilterRule>({
    rule_type: "and_cond",
    rules: [],
    is_not: false,
    is_case_sensitive: false,
  });

  return (
    <FilterBuilder
      value={filterRoot}
      onChange={setFilterRoot}
      availableColumns={[
        "name",
        "status",
        "client",
        "progress",
        "deadline",
      ]}
      showJsonPreview
    />
  );
}`;

  const installCommand = `npx shadcn@latest add @bluecopa-ui/filter-builder`;

  return (
    <ComponentPage
      title="Filter Builder"
      description="Unlimited-depth nested filter builder with support for AND/OR conditions, various operators, and case sensitivity."
      preview={
        <div className="w-full">
          <FilterBuilder
            value={filterRoot}
            onChange={setFilterRoot}
            availableColumns={[
              "name",
              "status",
              "client",
              "progress",
              "deadline",
            ]}
            showJsonPreview
          />
        </div>
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "FilterBuilderProps",
        props: [
          {
            name: "value",
            type: "FilterRule",
            description: "The filter rule tree. FilterRule can be 'and_cond', 'or_cond', or 'cond' with nested rules.",
          },
          {
            name: "onChange",
            type: "(next: FilterRule) => void",
            description: "Callback fired when the filter changes.",
          },
          {
            name: "availableColumns",
            type: "string[]",
            description: "Array of column names available for filtering.",
          },
          {
            name: "disabled",
            type: "boolean",
            description: "Disable the filter builder.",
          },
          {
            name: "className",
            type: "string",
            description: "Additional CSS classes.",
          },
          {
            name: "showJsonPreview",
            type: "boolean",
            description: "Show a JSON preview of the filter structure. Defaults to false.",
          },
        ],
      }}
    />
  );
}

